import axios from "axios";
import { toast } from 'react-toastify';
import localStorageServices from "./LocalStorage";
import { LocalStorageKeys } from "../constant/LocalStorageKeys";
import { logout } from "../redux/actionDispatcher/auth/authDispatcher";



// Example: Function to get data from an endpoint
export const fetchData = async (apiUrl) => {
  try {
    var header = {};
    const token = localStorageServices.getItem(LocalStorageKeys.userToken);
    if (token) {
      header.Authorization = `Bearer ${token.token}`

      console.log("TOKENNN:::::::::::",token.token);
      console.log("TOKENNN:::::::::::",apiUrl);

    }
    const response = await axios.get(apiUrl,{headers:header}); // Replace with your API endpoint
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error; // Throw error to handle it in the calling component
  }
};

export const patchData = async (apiUrl, payload = {}) => {
  try {
    let headers = {};
    const token = localStorageServices.getItem(LocalStorageKeys.userToken);

    if (token) {
      headers.Authorization = `Bearer ${token.token}`;
    }

    const response = await axios.patch(apiUrl, payload, { headers });
    console.log("response change email apijs r",response);
    if (response.data.status === 1) {
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);

    }
    return response.data;
  } catch (error) {
    handleErrors(error);
    toast.error(error.response.data.message);
console.log("response change email apijs err",error);
    throw error; // Throw error to handle it in the calling component
  }
};

// Example: Function to post data
export const postData = async (data, apiUrl) => {
  try {
    var header = {};
    const token = localStorageServices.getItem(LocalStorageKeys.userToken);
    if (token) {
      header.Authorization = `Bearer ${token.token}`
    }

    const response = await axios.post(apiUrl, data,{headers:header});
    if (response.data.status === 1) {
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);

    }
    return response.data;
  } catch (error) {

    handleErrors(error);
    console.error("Error posting data:", error);
    throw error;
  }
};




export const postMultipleData = async (dataArray, apiUrl) => {
  try {
    const header = {};
    const token = localStorageServices.getItem(LocalStorageKeys.userToken);
    if (token) {
      header.Authorization = `Bearer ${token.token}`;
    }

    let successCount = 0;
    let errorCount = 0;

    // Create an array of requests with POST or PUT based on "id" presence
    const requests = dataArray.map((data) => {
      const method = data.id ? "put" : "post"; // PUT for update, POST for new
      return axios({
        method: method,
        url: data.id?apiUrl+"/"+data.id:apiUrl,
        data: data,
        headers: header,
      })
        .then((response) => {
          if (response.data.status === 1) {
            successCount++;
          } else {
            errorCount++;
          }
          return response.data;
        })
        .catch((error) => {
          errorCount++;
          handleErrors(error);
          console.error("Error posting data:", error);
        });
    });

    // Execute all requests in parallel
    const responses = await Promise.all(requests);

    // Show summary messages
    if (successCount > 0) {
      toast.success(`${successCount} record(s) added/updated successfully.`);
    }
    if (errorCount > 0) {
      toast.error(`${errorCount} record(s) failed to add/update.`);
    }

    return responses;
  } catch (error) {
    console.error("Unexpected error in posting data:", error);
    throw error;
  }
};



// Example: Function to update data
export const updateData = async (data, apiUrl) => {
  try {
    var header = {};
    const token = localStorageServices.getItem(LocalStorageKeys.userToken);
    if (token) {
      header.Authorization = `Bearer ${token.token}`
    }
    const response = await axios.put(apiUrl, {"body":data},{headers:header});
    return response.data;
  } catch (error) {
    if(error.response.status){
      // logout()
    }
    console.error("Error updating data:", error);
    throw error;
  }
};

// Example: Function to delete data
export const deleteData = async (apiUrl) => {
  var header = {};
  const token = localStorageServices.getItem(LocalStorageKeys.userToken);
  if (token) {
    header.Authorization = `Bearer ${token.token}`
  }

  try {
    const response = await axios.delete(apiUrl,{headers:header});
    return response.data;
  } catch (error) {
    handleErrors(error);
    // toast.error(error.response.data.message);
    console.error("Error deleting data:", error);
    throw error;
  }
};


export const uploadImage = async (apiUrl,imageKeyName,file,imageUploadPath = "admin/profile-image") => {

  console.log(`Apiurl :-- ${apiUrl} imagekeyName ${imageKeyName},file ${file} , image upload path ${imageUploadPath}`)
  const formData = new FormData();
  formData.append(imageKeyName, file);
  formData.append("path", imageUploadPath);

  try {
      const response = await axios.post(
          apiUrl,
          formData,
          {
              headers: {
                  "Content-Type": "multipart/form-data",
              },
          }
      );
      console.log("Upload success:", response.data);
      return response.data;
  } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
  }
};


/**
 * Common function to handle validation errors
 */
const handleErrors = (error) => {
  let errorMessage = "Something went wrong!";

  if (error.response) {
    const { data } = error.response;

    // If there's a message, use it
    if (data.message) {
      errorMessage = data.message;
    }

    // Check if there's an "error" object with validation messages
    if (data.error && typeof data.error === "object" && Object.keys(data.error).length > 0) {
      errorMessage = Object.values(data.error).flat().join("\n"); // Join all errors into a single message
    }
  } else if (error.request) {
    errorMessage = "No response from server!";
  } else {
    errorMessage = error.message;
  }

  toast.error(errorMessage); // Show a single toast
};

/**
 * Common function to make POST API calls
 */